module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-news-headImg-box"
  }, [_c('el-form', {
    ref: "headImgForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_vm._l((_vm.headImgForm), function(imageItem, index) {
    return [_c('el-card', {
      staticClass: "box-card"
    }, [_c('el-form-item', {
      attrs: {
        "label": "图片链接",
        "prop": "image"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (_vm.headImgForm[index].image),
        callback: function($$v) {
          _vm.headImgForm[index].image = $$v
        },
        expression: "headImgForm[index].image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "落地链接",
        "prop": "link"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (_vm.headImgForm[index].link),
        callback: function($$v) {
          _vm.headImgForm[index].link = $$v
        },
        expression: "headImgForm[index].link"
      }
    })], 1)], 1)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [(_vm.headImgForm.length > 1) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.deleteHeadImgCard
    }
  }, [_vm._v("删除卡片")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addHeadImgCard
    }
  }, [_vm._v("增加卡片")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.clearAddNewsForm
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.createHeadImg
    }
  }, [_vm._v("确 定")])], 1), _vm._v(" "), _c('div', {
    staticClass: "preview-box"
  }, [_c('HeadImgComponent', {
    attrs: {
      "newsData": this.headImgForm,
      "isAd": false
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-76447ede"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/business/newsAddTemplate/HeadImg.vue
// module id = 780
// module chunks = 1